/* import __COLOCATED_TEMPLATE__ from './publish-all-sessions.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { all } from 'rsvp';
import { dropTask, timeout } from 'ember-concurrency';
import { TrackedAsyncData } from 'ember-async-data';
import { uniqueValues } from 'ilios-common/utils/array-helpers';
let PublishAllSessionsComponent = (_class = class PublishAllSessionsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor3, this);
    _initializerDefineProperty(this, "publishableCollapsed", _descriptor4, this);
    _initializerDefineProperty(this, "unPublishableCollapsed", _descriptor5, this);
    _initializerDefineProperty(this, "totalSessionsToSave", _descriptor6, this);
    _initializerDefineProperty(this, "currentSessionsSaved", _descriptor7, this);
    _initializerDefineProperty(this, "userSelectedSessionsToPublish", _descriptor8, this);
    _initializerDefineProperty(this, "userSelectedSessionsToSchedule", _descriptor9, this);
    _defineProperty(this, "save", _buildTask(() => ({
      context: this,
      generator: function* () {
        const sessionsToSave = [];
        this.overridableSessions.forEach(session => {
          session.set('publishedAsTbd', !this.sessionsToPublish.includes(session));
          session.set('published', true);
          sessionsToSave.push(session);
        });
        this.publishableSessions.forEach(session => {
          session.set('published', true);
          sessionsToSave.push(session);
        });
        this.totalSessionsToSave = sessionsToSave.length;
        this.currentSessionsSaved = 0;
        yield this.saveSomeSessions(sessionsToSave);
        this.flashMessages.success('general.savedSuccessfully');
        yield timeout(500);
        this.args.saved();
      }
    }), null, "save", "drop"));
  }
  get courseObjectivesData() {
    return new TrackedAsyncData(this.args.course.courseObjectives);
  }
  get sessionsData() {
    return new TrackedAsyncData(this.args.course.sessions);
  }
  get courseObjectives() {
    return this.courseObjectivesData.isResolved ? this.courseObjectivesData.value : null;
  }
  get sessions() {
    return this.sessionsData.isResolved ? this.sessionsData.value : [];
  }
  get publishedSessions() {
    return this.overridableSessions.filter(s => {
      return s.published && !s.publishedAsTbd;
    });
  }
  get unpublishedSessions() {
    return this.overridableSessions.filter(s => !this.publishedSessions.includes(s));
  }
  get sessionsToPublish() {
    const sessionsToPublish = [...this.publishedSessions, ...this.userSelectedSessionsToPublish];
    return uniqueValues(sessionsToPublish.filter(s => !this.userSelectedSessionsToSchedule.includes(s)));
  }
  get sessionsToSchedule() {
    const sessionsToPublish = [...this.unpublishedSessions, ...this.userSelectedSessionsToSchedule];
    return uniqueValues(sessionsToPublish.filter(s => !this.userSelectedSessionsToPublish.includes(s)));
  }
  get allSessionsScheduled() {
    return this.sessionsToSchedule.length === this.overridableSessions.length;
  }
  get allSessionsPublished() {
    return this.sessionsToPublish.length === this.overridableSessions.length;
  }
  get saveProgressPercent() {
    const total = this.totalSessionsToSave || 1;
    const current = this.currentSessionsSaved || 0;
    const floor = Math.floor(current / total * 100);
    if (!floor && this.save.isRunning) {
      return 1;
    }
    return floor;
  }
  get showWarning() {
    if (!this.courseObjectives) {
      return false;
    }
    return Boolean(this.courseObjectives.find(objective => {
      return objective.programYearObjectives.length === 0;
    }));
  }
  get publishableSessions() {
    return this.sessions.filter(session => {
      return session.allPublicationIssuesLength === 0;
    });
  }
  get unPublishableSessions() {
    return this.sessions.filter(session => {
      return session.requiredPublicationIssues.length > 0;
    });
  }
  get overridableSessions() {
    return this.sessions.filter(session => {
      return session.requiredPublicationIssues.length === 0 && session.optionalPublicationIssues.length > 0;
    });
  }
  get publishCount() {
    return this.publishableSessions.length + this.sessionsToPublish.length;
  }
  get scheduleCount() {
    return this.sessionsToSchedule.length;
  }
  get ignoreCount() {
    return this.unPublishableSessions.length;
  }
  toggleSession(session) {
    if (this.sessionsToPublish.includes(session)) {
      this.userSelectedSessionsToPublish = this.userSelectedSessionsToPublish.filter(s => s !== session);
      this.userSelectedSessionsToSchedule = [...this.userSelectedSessionsToSchedule, session];
    } else {
      this.userSelectedSessionsToSchedule = this.userSelectedSessionsToSchedule.filter(s => s !== session);
      this.userSelectedSessionsToPublish = [...this.userSelectedSessionsToPublish, session];
    }
  }
  publishAllAsIs() {
    this.userSelectedSessionsToSchedule = [];
    this.userSelectedSessionsToPublish = [...this.overridableSessions];
  }
  scheduleAll() {
    this.userSelectedSessionsToPublish = [];
    this.userSelectedSessionsToSchedule = [...this.overridableSessions];
  }
  async saveSomeSessions(sessions) {
    const chunk = sessions.splice(0, 6);
    await await all(chunk.map(o => o.save()));
    this.currentSessionsSaved += chunk.length;
    if (sessions.length) {
      await this.saveSomeSessions(sessions);
    }
  }
  async transitionToCourse() {
    const queryParams = {
      courseObjectiveDetails: true,
      details: true
    };
    this.router.transitionTo('course', this.args.course, {
      queryParams
    });
  }
  async transitionToVisualizeObjectives() {
    this.router.transitionTo('course-visualize-objectives', this.args.course);
  }
  transitionToSession(session) {
    const queryParams = {
      sessionObjectiveDetails: true
    };
    this.router.transitionTo('session', session, {
      queryParams
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "publishableCollapsed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "unPublishableCollapsed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "totalSessionsToSave", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentSessionsSaved", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "userSelectedSessionsToPublish", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "userSelectedSessionsToSchedule", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "courseObjectivesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseObjectivesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSession", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSession"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "publishAllAsIs", [action], Object.getOwnPropertyDescriptor(_class.prototype, "publishAllAsIs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scheduleAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "scheduleAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToCourse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToVisualizeObjectives", [action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToVisualizeObjectives"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToSession", [action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToSession"), _class.prototype), _class);
export { PublishAllSessionsComponent as default };